<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 30/11/2021
  -->

<template>
	<el-switch
		v-bind="attrsCustom"
		v-model="valueData"
		:active-text="activeTextComputed"
		:inactive-text="inactiveTextComputed"
		@change="notifyValueChanged">
		<slot></slot>
	</el-switch>
</template>

<script>


import BaseVModelView from "@/core/components/BaseVModelView.vue";

export default {
	name: "QwSwitch",
	extends: BaseVModelView,
	inheritAttrs: false,

	props: {
		inactiveText: String,
		activeText: String,
		inactiveValue: {default: false},
		activeValue: {default: true},
		showOnlyCurrentText: Boolean,
	},

	methods: {
		formatDataIn(data) {
			let res = data === this.activeValue
			console.log("QwSwitch: formatDataIn = ", data, ", res = ", res)
			return res
		},

		formatDataOut(data) {
			let res = data ? this.activeValue : this.inactiveValue
			console.log("QwSwitch: formatDataOut = ", data, ", res = ", res)
			return res
		}

	},

	computed: {
		currentText() {
			return this.modelValue ? this.activeText : this.inactiveText
		},

		activeTextComputed(){
			return this.showOnlyCurrentText ? this.currentText : this.activeText
		},

		inactiveTextComputed(){
			return this.showOnlyCurrentText ? "" : this.inactiveText
		},

		attrsCustom(){
			let {onInput, onChange, ...listenersCustom} = this.attrsListenersOnly
			delete listenersCustom["onUpdate:modelValue"]
			return {
				...this.attrsNoListeners,
				...listenersCustom,
			}
		}
	},
}
</script>

<style lang="scss">

</style>
